import React from 'react';
import { Card, CardHeader, CardContent } from '@mui/material';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';

interface PriceEnhancer {
  type: string;
  total: number;
  count: number;
  displayName: string;
}

interface PriceEnhancersSummaryProps {
  priceEnhancers: PriceEnhancer[];
}

const COLORS = ['#2A9D90', '#E76E50', '#274754', '#E8C468', '#F4A462'];

const PriceEnhancersSummary: React.FC<PriceEnhancersSummaryProps> = ({ priceEnhancers }) => {
  // Prepare data for Pie chart
  const pieData = (priceEnhancers || []).map((enhancer) => ({
    name: enhancer.displayName,
    value: enhancer.total,
    type: enhancer.type,
    count: enhancer.count
  }));

  return (
    <Card>
      <CardHeader title="Price Enhancers Contributions" />
      <CardContent>
        <div style={{ width: '100%', height: 300 }}>
          <ResponsiveContainer width="100%" height="100%">
            {pieData.length > 0 ? (
              <PieChart>
                <Pie
                  data={pieData}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={({ type, percent }) =>
                    `${type} ${(percent * 100).toFixed(0)}%`
                  }
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                >
                  {pieData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
                <Tooltip
                  formatter={(
                    value: number,
                    _name: string,
                    props: any
                  ) => {
                    const enhancer = priceEnhancers.find(
                      (e) => e.displayName === props.payload?.name
                    );
                    if (enhancer) {
                      return [
                        `$${enhancer.total.toFixed(2)} (Count: ${enhancer.count})`,
                        enhancer.displayName
                      ];
                    }
                    return [`$${value.toFixed(2)}`, props.payload?.name];
                  }}
                />
                <Legend />
              </PieChart>
            ) : (
              <div style={{ textAlign: 'center', color: '#888', marginTop: 100 }}>
                No price enhancer data available.
              </div>
            )}
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default PriceEnhancersSummary;
